export default "/assets/images/two-size-mila.ea37bba62fa9a3e6.webp";